import { createFileRoute } from '@tanstack/react-router';
import { EstablishmentRegistryPage } from './-components/EstablishmentRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/establishments/')({
  component: EstablishmentRegistryPage
});